import { Box, Typography, useTheme } from '@mui/material';
import { Ring } from './style';
//import './style.css'

export const RoundProgressBar = (props: { step: number; total: number }) => {
	const { step, total } = props;
	const theme = useTheme();
	const circleCSS = {};
	return (
		<Ring>
			{step > 0 && (
				<svg viewBox="0 0 36 36" className="circular-chart">
					<path
						className="circle"
						strokeDasharray={`${(step / total) * 100}, 100`}
						d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
					/>
				</svg>
			)}
			<Typography variant="semiCaption">{total}/</Typography>
			<Typography variant="semiCaption">{step}</Typography>
		</Ring>
	);
};
